import React, { useEffect, useRef } from 'react';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from './telemetryService';

interface TelemetryProviderProps {
	children: React.ReactNode;
	instrumentationKey: string;
	auth: { isAuthenticated: boolean; email: string };
}

const TelemetryProvider: React.FC<React.PropsWithChildren<TelemetryProviderProps>> = ({ children, instrumentationKey, auth }) => {
	const initialized = useRef(false);

	// instrumentationKey and auth both arrive asynchronously from redux, so this
	// effect handles either ordering: initialize once a key exists, then set or
	// clear the authenticated user as auth changes. Page views are captured by
	// enableAutoRouteTracking, so no manual trackPageView is needed.
	useEffect(() => {
		if (!instrumentationKey) {
			return;
		}

		if (!initialized.current) {
			ai.initialize(instrumentationKey);
			initialized.current = true;
		}

		ai.updateData(auth);
	}, [instrumentationKey, auth.isAuthenticated, auth.email]);

	return <>{children}</>;
};

export default withAITracking(ai.reactPlugin, TelemetryProvider);
